/**
 * Handles the zipcode form inside the dealer form.
 */

define('libs/dealerform.zipcodeform',['require','mustache','templates'],function(require) {

    'use strict';

    var Mustache = require('mustache'),
        templates = require('templates');

    var SETTINGS = {
            zipcodeFieldSelector: '.input-postcode',
            lookupButtonSelector: '.btn-postcode-lookup',
            listContainerSelector: '.dealer-select-list',
            template: 'dealerlist',
            classValid: 'valid',
            chunkSize: 6,
            lazyLoad: false,
            allowEnterKey: true,
            loadingClass: 'loading'
        },

        EVENT = {
            dealerlistBuild: 'zipcodeform.dealerlist.build',
            dealerlistFailed: 'zipcodeform.dealerlist.error'
        };


    var ZipcodeForm = function(root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.EVENT = EVENT;
        this.root = $(root);

        var btn = $(this.settings.lookupButtonSelector, root);
        this.field_zipcode = $(this.settings.zipcodeFieldSelector, root);
        this.lookup_url = root.getAttribute('data-url');
        this.chunk = 0;

        if (this.lookup_url && btn.length && this.field_zipcode.length) {
            btn.on('click', this.doLookup.bind(this));
            if (this.settings.allowEnterKey) {
                this.field_zipcode.on('keyup', this.onEnterKey.bind(this));
            }
        }
    };

    ZipcodeForm.prototype.onEnterKey = function(event) {
        if (event && event.which == 13) {
            // allow validation to run first
            setTimeout(this.doLookup.bind(this), 10);
        }
    };

    /**
     *
     */
    ZipcodeForm.prototype.doLookup = function(event) {
        if (event) {
            event.preventDefault();
        }
        // make sure the input gets validated.
        this.field_zipcode.data('changed.validation', true);
        this.field_zipcode.trigger('change');

        if (this.field_zipcode.hasClass(this.settings.classValid)) {
            this.userZipcode = this.field_zipcode[0].value.replace(/\s/g, '');



            /******** TMP ***********/
            //this.lookup_url = '../static/js/storedata.json';
            /******** TMP ***********/
            this.root.addClass(this.settings.loadingClass);

            $.ajax(this.lookup_url, {
                dataType: 'json',
                data: {postcode: this.userZipcode},
                success: this.processLookupResult.bind(this),
                error: this.onError.bind(this)
            });
        }
    };

    ZipcodeForm.prototype.processLookupResult = function(data) {
        // idd id to dealers.
        for (var i = 0; i < data.length; i++) {
            data[i].id = i;
            data[i].classHighlight  = data[i].storetype + '-store';
            data[i].more_stores_str = fs_obj.more_stores_str;
            data[i].show_on_map_str = fs_obj.show_on_map_str;
            data[i].directions_str  = fs_obj.directions_str;
            data[i].make_appoin_str = fs_obj.make_appoin_str;
            data[i].more_inform_str = fs_obj.more_inform_str;
            data[i].back_to_ove_str = fs_obj.back_to_ove_str;
        }

        // get greatest distance.
        var toSort = [].concat(data);
        toSort.sort(function(a, b) {
            if (a.distance < b.distance) {
                return 1;
            }
            if (a.distance > b.distance) {
                return -1;
            }
            // a must be equal to b
            return 0;
        });

        this.furthest = toSort[0].distance;


        this.data = data;
        this.showChunk(this.chunk, true);
        if (data.length > this.settings.chunkSize) {
            $(this.settings.listContainerSelector).addClass('more-dealers');
            $('button.show-more').show();
        }

        this.root.removeClass(this.settings.loadingClass);
    };

    ZipcodeForm.prototype.showChunk = function(chunk, replace) {
        var data = [];
        for (var i = chunk * this.settings.chunkSize; i < (chunk + 1) * this.settings.chunkSize; i++) {
            if (this.data[i]) {
                data.push(this.data[i]);
            }
        }

        var templateData = {
            zipcodeuser: this.userZipcode,
            count: this.data.length,
            dealers: data,
            more_stores_str: fs_obj.more_stores_str,
            show_on_map_str: fs_obj.show_on_map_str,
            make_appoin_str: fs_obj.make_appoin_str,
            more_inform_str: fs_obj.more_inform_str,
            back_to_ove_str: fs_obj.back_to_ove_str
        };

        if (chunk === 0) {
            templateData.intro = true;
            templateData.furthest = this.furthest;

            // find any SES stores and put them on top.
            var SESdealers = [];
            for (var i = 0; i < templateData.dealers.length; i++) {
                if (templateData.dealers[i].storetype == 'SES') {
                    SESdealers.push(templateData.dealers[i]);
                }
            }
            var filtered = templateData.dealers.filter(function(a) {
                return a.storetype != 'SES';
            });

            templateData.dealers = SESdealers.concat(filtered);
        }

        // build the dealer list and insert it into the form.
        var list = Mustache.to_html(templates[this.settings.template], templateData),
            container = $(this.settings.listContainerSelector);
        if (replace) {
            container.html($(list));
        } else {
            container.append($(list));
        }

        if ((this.chunk + 1) * this.settings.chunkSize >= this.data.length) {
            this.root.trigger('dealerlocator.endOfDealersReached');
        }

        this.root.trigger(this.EVENT.dealerlistBuild, {dealers: data});
    };

    ZipcodeForm.prototype.onError = function(data, e) {
        // do something on error / no results.
        location.href = 'error.html';
        this.root.trigger(this.EVENT.dealerlistFailed);
    };


    return ZipcodeForm;
});

